import { UIHeading4 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './QuickLinksList.css';
import { QuickLinkItem } from './components/QuickLinkItem';
import { trackQuickLinksView } from '../../utils/tracking';
import { IOldQuickLink } from '../../../../../types/quickLinks';

export interface IQuickLinksListProps {
  linkGroups: IOldQuickLink[][];
}

export function QuickLinksList(props: IQuickLinksListProps) {
  const { linkGroups } = props;

  React.useEffect(() => {
    trackQuickLinksView();
  }, []);

  return (
    <div className={styles['section']}>
      <UIHeading4 as="h4" whiteSpace="nowrap">
        Рекомендуем посмотреть
      </UIHeading4>
      <div className={styles['list']}>
        {linkGroups.map((links, index) => {
          return (
            <div key={`quicks_link_${index}`} className={styles['column']}>
              {links.map((link, i) => {
                return (
                  <QuickLinkItem
                    key={`quick_link_${i}`}
                    url={link.url}
                    offersCount={link.offersCount}
                    title={link.title}
                  />
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}
